import api, { ApiResponse } from "./api";
import Token from "../config/token.service";
import { User } from "../types/user";

const API_URL = "v1/user/";

class AuthService {
    async login(email: string, password: string) {
        const response = await api
            .post(API_URL + "login", {
                email,
                password
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    const v = response.data.v;
                    const user = new User(
                        v.id,
                        v.businessName,
                        v.email,
                        v.mobile,
                        v.addressLine1,
                        v.addressLine2,
                        v.country,
                        v.province,
                        v.city,
                        v.postalCode,
                        v.category,
                        v.status
                    );
                    Token.setUser(user, v.token);
                }
                return response.data;
            })
            .catch(error => {
                return { "c": 0, "message": error };
            });
        
        return response;
    }

    async signup(
        businessName: string,
        email: string,
        password: string,
        category: number,
        mobile: string,
        addressLine1: string,
        addressLine2: string,
        country: string,
        province: string,
        city: string,
        postalCode: string
    ) {
        const response = await api
            .post(API_URL + "signup", {
                businessName,
                email,
                password,
                category,
                mobile,
                addressLine1,
                addressLine2,
                country,
                province,
                city,
                postalCode
            })
            .then((response: ApiResponse) => {
                return response.data;
            })
            .catch(error => {
                return { "c": 0, "message": error };
            });

        return response;
    }

    async update(
        id: number,
        businessName: string,
        email: string,
        password: string,
        mobile: string,
        addressLine1: string,
        addressLine2: string,
        country: string,
        province: string,
        city: string,
        postalCode: string
    ) {
        const response = await api
            .post(API_URL + "update", {
                id,
                businessName,
                email,
                password,
                mobile,
                addressLine1,
                addressLine2,
                country,
                province,
                city,
                postalCode
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    const v = response.data.v;
                    const user = new User(
                        v.id,
                        v.businessName,
                        v.email,
                        v.mobile,
                        v.addressLine1,
                        v.addressLine2,
                        v.country,
                        v.province,
                        v.city,
                        v.postalCode,
                        v.category,
                        v.status
                    );
                    Token.setUser(user, v.token);
                }
                return response.data;
            })
            .catch(error => {
                return { "c": 0, "message": error };
            });

        return response;
    }

    async status(uid: number) {
        const response = await api
            .post(API_URL + "status/query", {
                uid
            })
            .then((response: ApiResponse) => {
                if (response.data.c === 1) {
                    return response.data.v;
                }
                return "pending";
            })
            .catch(() => {
                return "pending";
            });

        return response;
    }
}

const authService = new AuthService();

export default authService;
